module.exports = __webpack_public_path__ + "static/media/mika.mielonen.34bc6ab8.jpg";